var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Carat")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 220a12 12 0 0 1-8.485-20.485L159.029 128 87.515 56.485a12 12 0 0 1 16.97-16.97l80 80a12 12 0 0 1 0 16.97l-80 80A11.96 11.96 0 0 1 96 220"
  })));
};
export default SvgCaret;